export const PUBLISH_EXAM_RESULT_FORM_KEYS = {
  questionairre_uid: "questionairre_uid",
};
